const { getError } = require('../tools')
const baseUrl = 'https://staging-liink.stockone.com/api/v1/base/connectors/Field'
const workspace = 'FIELD_SUPPLY'

function shipsyFetch ({ logger, fetch, token }) {
  const fetcher = async ({ path, body, method }) => {
    const url = `${baseUrl}${path}`

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
      'workspace': workspace
    }

    const payload = JSON.stringify(body)

    logger.info({ url, method, path }, 'shipsy:request')

    const res = await fetch(url, {
      method,
      headers,
      body: payload
    })

    if (!res.ok) {
      const err = await getError(res)
      if (err) throw err
      return
    }

    return res
  }

  return fetcher
}

module.exports = shipsyFetch
